// interfaces/types
import type { Accessory } from '@makemydeal/dr-dash-types';
import type { ColumnMappings } from './manualAccessoriesTypes';

// utils
import { makeRequired, makeMaxLength } from '@makemydeal/dr-shared-ui-utils';

// consts/enums
import { ACCESSORY_FIELD_NAMES, ACCESSORY_NAME_MAX_LENGTH, REQUIRED } from '../../constants';

export const buildColumnMappings = ({
    amount,
    name,
    code,
    cost,
    profit,
    residual,
    upFront,
    weOwe,
    install
}: Accessory): ColumnMappings => ({
    Name: {
        fieldName: ACCESSORY_FIELD_NAMES.NAME,
        value: name,
        required: true
    },
    ID: {
        fieldName: ACCESSORY_FIELD_NAMES.CODE,
        value: code,
        required: false
    },
    Cost: {
        fieldName: ACCESSORY_FIELD_NAMES.COST,
        value: cost,
        required: true
    },
    Sale: {
        fieldName: ACCESSORY_FIELD_NAMES.AMOUNT,
        value: amount,
        required: true
    },
    Install: {
        fieldName: ACCESSORY_FIELD_NAMES.INSTALL_PRICE,
        value: install,
        required: false
    },
    Residual: {
        fieldName: ACCESSORY_FIELD_NAMES.RESIDUAL,
        value: residual,
        required: false
    },
    Profit: {
        fieldName: ACCESSORY_FIELD_NAMES.PROFIT,
        value: profit,
        required: false
    },
    Upfront: {
        fieldName: ACCESSORY_FIELD_NAMES.UP_FRONT,
        value: upFront,
        required: false,
        type: 'checkbox',
        label: 'Upfront'
    },
    WeOwe: {
        fieldName: ACCESSORY_FIELD_NAMES.WE_OWE,
        value: weOwe,
        required: false,
        type: 'checkbox',
        label: 'We Owe'
    }
});
export const accessoryHasErrors = (accessoriesValidity: Record<string, string>): boolean =>
    Object.values(accessoriesValidity).some((status) => status === 'invalid' || status === 'invalidSuppressed');

export const getLabelWithRequiredHint = (label: string, isOptionalDeskingMode?: boolean): string =>
    isOptionalDeskingMode ? `${label} (required)` : label;

export const accessoryValidationRules = {
    name: [
        makeRequired(REQUIRED),
        makeMaxLength(ACCESSORY_NAME_MAX_LENGTH, `Value should be less than ${ACCESSORY_NAME_MAX_LENGTH} symbols.`)
    ]
};
